/**
 * application state への当てはめ（React 非依存）。
 * domain の build*AppStatePatch 結果を prev state に反映する。setState は orchestrator が実行する。
 */

/**
 * @param {Object} prev
 * @param {Object} patch
 * @param {boolean} [patch.addRepeater]
 * @param {Object[]} [patch.repeaterSerials]
 * @param {Object} [patch.trunkingItemPatch]
 * @param {Object} [patch.validationErrorsPatch]
 */
export function applyAppStatePatch(prev, patch) {
    if (patch == null) {
        return prev;
    }

    let next = prev;
    if (patch.gen1Order !== undefined) {
        next = { ...next, gen1Order: patch.gen1Order };
    }

    if (patch.selectedCustomerAddressBookId !== undefined) {
        next = {
            ...next,
            selectedCustomerAddressBookId: patch.selectedCustomerAddressBookId,
        };
    }

    if (patch.isSaveAddressBook !== undefined) {
        next = { ...next, isSaveAddressBook: patch.isSaveAddressBook };
    }

    if (patch.orderNumber !== undefined) {
        next = { ...next, orderNumber: patch.orderNumber };
    }

    if (patch.otherSystemId !== undefined) {
        next = { ...next, otherSystemId: patch.otherSystemId };
    }

    if (patch.addRepeater !== undefined) {
        next = { ...next, addRepeater: patch.addRepeater };
    }

    const hasTrunkingItemPatch =
        patch.trunkingItemPatch != null &&
        Object.keys(patch.trunkingItemPatch).length > 0;

    const hasRepeaterUpdate =
        patch.repeaterSerials !== undefined || hasTrunkingItemPatch;
    if (hasRepeaterUpdate) {
        const gen1Order = { ...next.gen1Order };
        if (patch.repeaterSerials !== undefined) {
            gen1Order.Gen1TrunkingOrderRepeaterSerials = patch.repeaterSerials;
        }
        if (hasTrunkingItemPatch) {
            gen1Order.Gen1TrunkingOrderItem = {
                ...gen1Order.Gen1TrunkingOrderItem,
                ...patch.trunkingItemPatch,
            };
        }
        next = { ...next, gen1Order };
    }

    if (
        patch.validationErrorsPatch != null &&
        Object.keys(patch.validationErrorsPatch).length > 0
    ) {
        next = {
            ...next,
            validationErrors: {
                ...next.validationErrors,
                ...patch.validationErrorsPatch,
            },
        };
    }

    return next;
}
